<template>
  <b-card no-body>
    <b-card-body>
      <div class="chart-title text-center mb-2">
        {{ titleText }}
      </div>
      <vue-apex-charts
        ref="barChart"
        type="bar"
        height="350"
        :options="chartOptions"
        :series="series"
      />
    </b-card-body>
  </b-card>
</template>

<script>
import { BCard, BCardBody, BCardHeader, BCardTitle } from "bootstrap-vue";
import VueApexCharts from "vue-apexcharts";
import flatPickr from "vue-flatpickr-component";
// import apexChatData from "./apexChartData";
import * as apiDashboard from "@/store/api/dashboard/index.js";
import * as userData from "@/auth/localStorageUtils.js";
import chartColor from "./ChartColor";
import { fa } from "vuejs-datepicker/src/locale";

export default {
  components: {
    BCard,
    BCardBody,
    BCardHeader,
    VueApexCharts,
    flatPickr,
    BCardTitle,
  },
  props: {
    issueName: {
      type: String,
      default: "",
    },
    // year: {
    //   type: Number,
    //   default: new Date().getFullYear(),
    // },
    // departmentId: {
    //   type: String,
    //   default: "",
    // },
    titleText: {
      type: String,
      default: "",
    },
    filter: {
      type: Object,
      default: () => ({
        year: new Date().getFullYear().toString(),
        yearEnd: new Date().getFullYear().toString(),
        startDate: "",
        endDate: "",
        userId: userData.userId(),
        departmentId: userData.departmentId(),
      }),
    },
  },
  data() {
    return {
      series: [
        {
          name: "กำลังโหลดข้อมูล...",
          data: [], // [44, 55, 41, 67, 22, 43]
        },
        {
          name: "กำลังโหลดข้อมูล...",
          data: [], // [13, 23, 20, 8, 13, 27]
        },
      ],
      chartOptions: {
        chart: {
          type: "bar",
          stacked: true,
          toolbar: {
            show: false,
          },
        },
        // title: {
        //   text: this.titleText,
        //   align: "left",
        //   style: {
        //     fontSize: "16px",
        //     whiteSpace: 'normal'
        //   },
        // },
        dataLabels: {
          enabled: true
        },
        plotOptions: {
          bar: {
            horizontal: true,
          },
        },
        xaxis: {
          categories: [], // ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        },
        legend: {
          position: "bottom",
        },
        fill: {
          opacity: 1,
        },
        noData: {
          text: "ไม่พบข้อมูล",
          align: "center",
          verticalAlign: "middle",
        },
        responsive: [
          {
            breakpoint: 1000,
            options: {
              plotOptions: {
                bar: {
                  horizontal: false,
                },
              },
              legend: {
                position: "bottom",
              },
            },
          },
        ],
      },
    };
  },
  mounted() {
    this.max = chartColor.color.length;
    if (this.issueName === "FASTTRACK_SEND_RECIEVE_FROM_COMPANY") {
      this.funcGetSummaryFasttrackSendToAndRecieveFromCompany(this.filter);
    }
  },
  // watch: {
  //   seriesCustomize: function(newVal, oldVal) {
  //     //console.log
  //     //   "@watch seriesCustomize newVal: ",
  //     //   newVal,
  //     //   " | oldVal: ",
  //     //   oldVal
  //     // );
  //     // this.updateBarChart();
  //   },
  // },
  created() {
    window.addEventListener("resize", this.myEventHandler);
  },
  destroyed() {
    window.removeEventListener("resize", this.myEventHandler);
  },
  methods: {
    // getChartColor(n) {
    //   this.columChart.chartOptions.colors = [];
    //   this.columChart.chartOptions.dataLabels.style.colors = [];
    //   for (let i = 0; i < n; i++) {
    //     let idx = Math.floor(
    //       Math.random() * (this.max - this.min + 1) + this.min,
    //     );
    //     this.columChart.chartOptions.colors.push(this.chartColor.color[idx]);
    //     this.columChart.chartOptions.dataLabels.style.colors.push(
    //       this.chartColor.color[idx],
    //     );
    //   }
    // },
    // generatorColor(n) {
    //   this.columChart.chartOptions.colors = [];
    //   this.columChart.chartOptions.dataLabels.style.colors = [];
    //   for (let i = 0; i < n; i++) {
    //     let hex = (Math.random() * 0xfffff * 1000000).toString(16);
    //     this.columChart.chartOptions.colors.push("#" + hex.slice(0, 6));
    //     this.columChart.chartOptions.dataLabels.style.colors.push(
    //       "#" + hex.slice(0, 6),
    //     );
    //   }

    //   // this.updateBarChart();
    // },
    funcGetSummaryFasttrackSendToAndRecieveFromCompany(obj) {
      const self = this;

      console.log("start call api");

      // // ===== series =====
      // self.series = [
      //   { name: "Send", data: [10, 20] },
      //   { name: "Receive", data: [20, 30] },
      // ];
      // self.chartOptions.xaxis = {
      //   categories: ["Send", "Receive"],
      // };

      // console.log("series", self.columChart.series);
      // console.log("categories", self.columChart.chartOptions.yaxis.categories);
      // ===== options =====
      // self.columChart.chartOptions.chart.stacked = true;
      // self.columChart.chartOptions.plotOptions.bar.distributed = false;
      // self.columChart.chartOptions.legend.show = true;
      // console.log("options", self.columChart.chartOptions);

      // this.updateBarChart();

      apiDashboard
        .GetBarChart_SummaryFasttrackSendToAndRecieveFromCompany(self.filter)
        .then((response) => {
          const data = response.data.data || [];
          console.log("responseapi", data);

          // ===== series =====
          this.series = [
            {
              name: "จำนวนครั้งที่ สคบ. ส่งเรื่องไปยังไปผู้ประกอบการ",
              data: data.map((value) => value.sendTotal),
            },
            {
              name: "จำนวนครั้งที่ สคบ. ได้รับเรื่องคืนจากผู้ประกอบการ",
              data: data.map((value) => value.receiveTotal),
            },
          ];

          // ===== x-axis =====
          this.chartOptions.xaxis.categories = data.map((value) => value.name);
          console.log("x-axis", this.chartOptions.xaxis);

          this.updateBarChart(data);
        })
        .catch((error) => {
          console.error(error);
        });
    },
    // funcGetBarChart_SummaryFasttrackTransactionUser(obj) {
    //   const self = this;

    //   apiDashboard
    //     .GetBarChart_SummaryFasttrackTransactionUser(obj)
    //     .then((response) => {
    //       self.seriesCustomize = response.data.data.map((value) => value.total);
    //       self.labelsCustomize = response.data.data.map((value) => value.name);

    //       self.columChart.series[0].data = self.seriesCustomize;
    //       self.columChart.chartOptions.xaxis.categories = self.labelsCustomize;
    //       if (self.seriesCustomize) {
    //         this.getChartColor(self.seriesCustomize.length);
    //       }
    //       this.updateBarChart();
    //     })
    //     .catch((error) => {
    //       //console.log("error", error);
    //     });
    // },
    updateBarChart(apiData) {
      // redraw:
      // true = ทำการลบกราฟเดิม แล้วสร้างกราฟใหม่ทั้งหมด
      // false = อัพเดทเฉพาะส่วนที่เปลี่ยนแปลง

      // animate:
      // true = มี animation ตอนเปลี่ยนค่า
      // false = เปลี่ยนทันที ไม่มี animation

      // อัพเดทข้อมูล
      this.$refs["barChart"].updateSeries([
        {
          data: this.series,
        },
        false, // redraw
        true, // animate
      ]);

      // อัพเดทแกน ในที่นี้คือ แกน x
      this.$refs["barChart"].updateOptions(
        {
          xaxis: {
            categories: apiData.map((v) => v.name),
          },
        },
        false, // redraw
        true, // animate
      );

      // this.$refs["barChart"].refresh();
    },
    myEventHandler(e) {
      this.$refs["barChart"].refresh();
    },
  },
};
</script>

<style lang="scss" scoped>
.chart-title {
  font-weight: 600;
  line-height: 1.3;
}

/* mobile */
@media (max-width: 576px) {
  .chart-title {
    font-size: 0.9rem;
  }
}

/* desktop */
@media (min-width: 992px) {
  .chart-title {
    font-size: 1.05rem;
  }
}

</style>
